import { FacetCategory, IFacetGroup } from "shared/models/facet";

import { ActionType, IAction } from "store/types";

// ============================== Store Types =========================================================================

export enum FacetStoreKey {
  ProductionType = "productionTypes",
  ContractType = "contractTypes",
  Gender = "genders",
  Appearance = "appearances",
  Disability = "disabilities",
  ComplaintCategory = "complaintCategories",
  HeritageAndEthnicity = "heritageAndEthnicity",
  EthnicBackground = "ethnicBackground",
}

export interface IFacetState {
  [FacetStoreKey.ProductionType]?: IFacetGroup[];
  [FacetStoreKey.ContractType]?: IFacetGroup[];
  [FacetStoreKey.Gender]?: IFacetGroup[];
  [FacetStoreKey.Appearance]?: IFacetGroup[];
  [FacetStoreKey.Disability]?: IFacetGroup[];
  [FacetStoreKey.ComplaintCategory]?: IFacetGroup[];
  [FacetStoreKey.EthnicBackground]?: IFacetGroup[];
  [FacetStoreKey.HeritageAndEthnicity]?: IFacetGroup[];
  locale: string;
}

// ============================== Actions Types =======================================================================

export type SetCategory = (
  key: FacetStoreKey,
  data: IFacetGroup[],
  locale: string
) => IAction<
  ActionType.SetCategory,
  { key: FacetStoreKey; data: IFacetGroup[]; locale: string }
>;

export type SetCategories = (
  data: Partial<IFacetState>,
  locale: string
) => IAction<
  ActionType.SetCategories,
  { data: Partial<IFacetState>; locale: string }
>;

export type GetFacets = (
  categories: FacetCategory[],
  locale: string
) => Promise<void>;

export type FacetActions = ReturnType<SetCategory> | ReturnType<SetCategories>;
